<template>
  <div>
    <section class="">
      <div
        class="banner"
        :style="{backgroundImage: `url(${require(`@/assets/activity/10942678972571@2x.jpg`)})`,backgroundSize: `100% 100%`,'height': `380px` }"
      />
    </section>
    <section class="container">
      <div v-if="step === 1">
        <div class="fz-small mb-m">
          <h3>強制險過期一張罰單可抵三年保費，透過磐石保經網路投保強制險，保險不過期、保費更優惠！</h3>
          <p style="text-indent : 2em ;">根據強制汽車責任保險法第49條第1項規定：</p>
          <p style="text-indent : 2em ;">投保義務人未依本法規定訂立本保險契約，或本保險期間屆滿前未再行訂立者，其處罰依下列各款規定：</p>
          <p
            style="text-indent : 4em ;"
          >一、經公路監理機關或警察機關攔檢稽查舉發者，由公路主管機關處以罰鍰。為汽車者，處新臺幣3,000元以上1,5000元以下罰鍰；為機車者，處新臺幣1,500元以上3,000元以下罰鍰。</p>
          <p style="text-indent : 4em ;">二、未投保汽車肇事，由公路監理機關處新臺幣6,000元以上30,000元以下罰鍰，並扣留車輛牌照至其依規定投保後發還。</p>
          <p
            style="text-indent : 2em ;"
          >到期未投保汽機車強制得不償失，磐石保經網路投保網站推出強制險預約功能，強制險尚未到期也可先行預約，只需填寫車牌號碼及強制險生效日期，到期前系統自動通知投保，透過磐石網站投保強制險更簡單、更便宜。</p>
        </div>
        <div class="text-center mb-m">
          <Button v-show="isLogin === false" 
            class="btn-m btn-primary"
            :style="{margin: '0 15px'}"
            @click="next"
            v-text="'已是會員'"
          />
          <Button v-show="isLogin === true"
            class="btn-m btn-primary"
            :style="{margin: '0 15px'}"
            @click="next"
            v-text="'預約'"
          />
          <router-link to="/signup">
            <Button v-show="isLogin === false" class="btn-m btn-tertiary" v-text="'尚未成為會員，去註冊'" />
          </router-link>
        </div>
        <div class="note">
          <div class="note-header">注意事項：</div>
          <p>
            1. 使用此提醒功能，必須為磐石保經網路投保會員。
            2. 汽車強制險快到期者，磐石保經將在到期前60日提醒通知。
          </p>
        </div>
      </div>
      <div v-if="step === 2">
        <h2 class="mb-s" v-text="`填寫車輛資料`" />
        <Form
          ref="reserveData"
          label-position="left"
          :label-width="115"
          :model="model"
          :rules="rules"
          class="form-flex middle"
        >
          <DatePickerInput
            v-model="model.inceptionDate.compulsory"
            prop="inceptionDate"
            label="強制險到期日期"
             tips="(不知道到期日期請填發照日期)"
          />
          <!--
            <DatePickerInput
            v-model="model.inceptionDate.compulsory"
            prop="inceptionDate"
            label="強制險生效日期"
            tips="中午12時起，一年"
          />
            <Select
            size="large"
            v-model="model.insurance_kind"                      
            label="險種"
            placeholder="您的車種"                     
          >
            <Option
              v-for="option in insurance_kind_list"
              :key="`option-${option.value}`"
              :value="option.value"
              :label="option.label"
            />
          </Select>-->
          <BaseVueSelect
            v-model="model.insurance_kind"
            label="險種"
            prop="carType"
            :options="insurance_kind_list"
            :placeholder="您的車種"
          />
          <CarNoGroup v-model="model.carNo" prop="carNo" :label-width="111" />
        </Form>
        <div class="text-center mt-s">
          <Button class="btn-m btn-primary" @click="handleSubmit" v-text="'送出'" />
        </div>
      </div>
    </section>
    <OkModal v-if="dialog"
    :okMsg="okMsg" />
  </div>
</template>

<script>
//npm
import { EventLog } from "@/utils/axios";
//vuex
import { mapState, mapMutations } from "vuex";
import { Button, Form, Checkbox } from "iview";
import BaseVueSelect from "@/components/forms/elements/BaseVueSelect";
import DatePickerInput from "@/components/forms/elements/DatePickerInput";
import CarNoGroup from "@/components/forms/elements/CarNoGroup";
// validate rules
import {
  inceptionDateForCom as inceptionDate,
  carNoBase as carNo,
  carType
} from "@/utils/asyncValidator/rules";
import OkModal from "@/components/modals/OKModal";
import format from "date-fns/format";
import { UPDATE_ACTIVITY_RESERVECARINSU_MUTATION } from "@/store/modules/user/constants";

export default {
  components: {
    Button,
    Form,
    Checkbox,
    DatePickerInput,
    CarNoGroup,
    BaseVueSelect,
    OkModal
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    insurance_kind_list: {
      type: Array,
      default: [
        { label: "汽車", value: "AUT" },
        { label: "機車", value: "MOT" }
      ]
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: { inceptionDate, carNo },
      model: {
        inceptionDate: {
          //compulsory: format(new Date().setDate(new Date().getDate() + 1), "YYYY-MM-DD")         
           compulsory: format(new Date(), "YYYY-MM-DD")
        },
        carNo: {
          block1: "",
          block2: ""
        },
        insurance_kind: ""
      },
      okMsg:
      {
       title:"恭喜您已預約成功", 
       msgcontent:"我們將在預約日前前二個月通知提醒您透過網路投保完成您的車險投保,為您的愛車提供更完整的保障!"
      }
    };
  },
  computed: {
    step() {
      const { step } = this.$route.params;
      return step || 1;
    }
  },
  /*mounted() {
    this.$refs.VueModal.on("hidden.bs.modal", this.hreflocal);
    // $(this.$refs.VueModal).on("hidden.bs.modal", this.hreflocal);
  },*/
  methods: {
    ...mapMutations([UPDATE_ACTIVITY_RESERVECARINSU_MUTATION]),
    async next() {
      const activityData = { name: "activiyReserveCarInsuReserve" };
      await this.$store.commit(
        UPDATE_ACTIVITY_RESERVECARINSU_MUTATION,
        activityData
      );
      this.$router.push({
        name: "activiyReserveCarInsuReserve",
        params: {
          step: 2
        }
      });
    },
    async handleSubmit() {
      const { model, $refs } = this;
      const isValid = await $refs.reserveData.validate(v => v);
      if (!isValid) return;
      const ajaxStatus = await EventLog(model);
      //console.log(ajaxStatus);
      if (ajaxStatus) {
        //console.log(this.dialog);
        this.dialog = true;
        //console.log(this.OkModal.event.);
        // console.log(this.OkModal.value);
        //if( this.dialog==false){
        //window.location.href = "@pages/index";
        // }
              }
      //console.log(compulsory);
    }
  }
};
</script>